'use client'

import config from 'config'
import { useForm } from 'react-hook-form'
import { useBannerActions } from 'src/components/banner-callout/use-banner-actions'
import { srAnnounce } from 'src/lib/util/srAnnounce/v2/sr-announce'

type RecoverPasswordFormData = {
  user: string
}

export const useRecoverPassword = () => {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting }
  } = useForm<RecoverPasswordFormData>()
  const { setBanner } = useBannerActions()

  const onSubmit = async (data: RecoverPasswordFormData) => {
    try {
      const response = await fetch(
        `${config.NEXT_PUBLIC_GALACTUS_URL}/recover-password`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ user: data.user })
        }
      )

      if (!response.ok) {
        const errorMsg = await response.json()
        setBanner({
          message: errorMsg || 'Failed to recover password',
          calloutType: 'error'
        })
        srAnnounce(errorMsg || 'Failed to recover password', {
          assertive: true
        })
        throw new Error(errorMsg || 'Failed to recover password')
      }

      setBanner({
        message: 'Password reset instructions sent to your email.',
        calloutType: 'info'
      })
      srAnnounce('Password reset instructions sent to your email.')
    } catch (error) {
      const errorMessage =
        error instanceof Error
          ? error.message
          : 'An error occurred while processing your request'
      setBanner({
        message: errorMessage,
        calloutType: 'error'
      })
      srAnnounce(errorMessage, { assertive: true })
    }
  }

  return {
    register,
    handleSubmit,
    onSubmit,
    errors,
    isSubmitting
  }
}
